import { useState } from 'react';
import { EERIE } from 'HubStyleTokens/colors';
import { H1 } from 'UIComponents/elements/headings';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UIModal from 'UIComponents/dialog/UIModal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FlexibleAssociationSelect from 'automation-ui-associations/components/FlexibleAssociationSelect';
import { useAssociationDefinitions } from 'automation-ui-associations/hooks/associationDefinitionsHooks';
import AddDataSourceBasicSortBy from 'automation-ui-formula-editor/fetch-object-panel/containers/AddDataSourceBasicSortBy';
import getSpecFromFullAssociationTypeIdString from 'automation-ui-associations/utils/getSpecFromFullAssociationTypeIdString';
import findAssociationDefinitionFromSpec from 'automation-ui-associations/utils/findAssociationDefinitionFromSpec';
import { ONE_TO_MANY } from 'automation-ui-associations/constants/AssociationCardinality';
import AddDataSourceFilterRecordsByTypes from 'automation-ui-formula-editor/fetch-object-panel/constants/AddDataSourceFilterRecordsByTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AddDataSourceSelectAssociation = ({
  flowObjectTypeId,
  onChange,
  onSortByChange,
  selectRecordByValue,
  toObjectTypeId,
  value = '',
  filterTargetType,
  isNewDataSource,
  readOnly
}) => {
  const associationDefinitionsQuery = useAssociationDefinitions([flowObjectTypeId]);
  const [isAssociationLabelsModalVisible, setIsAssociationLabelsModalVisible] = useState(false);
  const selectedAssociationSpec = getSpecFromFullAssociationTypeIdString(value);
  const selectedAssociationDefinition = findAssociationDefinitionFromSpec(selectedAssociationSpec, associationDefinitionsQuery);
  const isOneToMany = selectedAssociationDefinition && selectedAssociationDefinition.cardinality === ONE_TO_MANY;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      borderInlineStartWidth: "300",
      borderInlineStartStyle: "solid",
      borderInlineStartColor: "border-core-subtle",
      marginInlineStart: "500",
      paddingInlineStart: "500",
      marginBlock: "400",
      children: /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.select-association.title"
          }), /*#__PURE__*/_jsxs(UILink, {
            className: "p-left-2",
            onClick: () => setIsAssociationLabelsModalVisible(true),
            children: [/*#__PURE__*/_jsx(UIIcon, {
              name: "info",
              color: EERIE
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.select-association.link-title"
            })]
          })]
        }),
        children: /*#__PURE__*/_jsx(FlexibleAssociationSelect, {
          label: null,
          readOnly: readOnly,
          fromObjectTypeId: flowObjectTypeId,
          toObjectTypeId: toObjectTypeId,
          onChange: event => {
            onChange(event.target.value.value, event.target.value.text);
          },
          value: value,
          dataTestId: "fetch-object-flexible-association-select-dropdown",
          supportsNonFlexibleAssociations: true
        })
      })
    }), value && isOneToMany && /*#__PURE__*/_jsx(AddDataSourceBasicSortBy, {
      onSortByChange: onSortByChange,
      flowObjectTypeId: flowObjectTypeId,
      toObjectTypeId: toObjectTypeId,
      selectRecordByValue: selectRecordByValue,
      recordFilterType: AddDataSourceFilterRecordsByTypes.ASSOCIATION_LABEL,
      filterTargetType: filterTargetType,
      isNewDataSource: isNewDataSource,
      readOnly: readOnly
    }), isAssociationLabelsModalVisible && /*#__PURE__*/_jsxs(UIModal, {
      use: "conversational",
      width: 450,
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H1, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.select-association.ui-modal.title"
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: () => setIsAssociationLabelsModalVisible(false)
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        paddingBlockStart: "600",
        paddingBlockEnd: "1000",
        children: /*#__PURE__*/_jsxs(Text, {
          textAlign: "start",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.select-association.ui-modal.text"
          }), ' ', /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: "",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.select-association.ui-modal.link-title"
            })
          })]
        })
      })]
    })]
  });
};
export default AddDataSourceSelectAssociation;